export default {
  Copy: '複製文本',
  Copy_markdown: '複製 Markdown',
  Copy_Success: '複製成功',
  Regenerate: '重新生成',
  Download_image: '下載圖片',
  Download_Markdown: '下載 Markdown',

  // exportRecord
  Cancel: '取消',
  Select_all: '選中全部',
  messages_selected: '條信息已選中',

  ask_answer: {
    title: '智能對談・高效創作・專業呈現',
    ppt_des: 'AI 簡報工具 - PowerPoint',
    pdf_des: '獲取即時摘要',
    image_des: '立即建立 Al 圖像',
    upgrade: '訂閱 Pro 或者 Unlimited',
    footer: '© 版權所有 2026 Sunstack Limited。| 保留所有權利'
  }
}
